import { Helmet } from 'react-helmet';

import {
  AddressBook,
  AffirmBanner,
  AffirmCartOptionText,
  AffirmEstimateCTA,
  AppProvider,
  AutoOfferModalButton,
  BrowserInfoHiddenFields,
  BulkSaleModalButton,
  BumpBid,
  BumpDisplay,
  ListingRowBumpButton,
  CartItemActions,
  CategoryNestedNav,
  CheckoutAddressBook,
  CombineAndSaveRow,
  CreateOfferButton,
  EmailSignUpEmbed,
  EuOdrDetailsContainer,
  EuOdrDetailsDashboardContainer,
  FeedbackContainer,
  FreeShippingProgressBarContainer,
  GiftCardSendDatePicker,
  HomepageCuratedSetRow,
  Item2ShippingPrompt,
  ItemRelatedBuyingGuide,
  Spinner,
  setRoutes,
  LightboxImage,
  ListingRow,
  ListingSidebarCSP,
  LocalePickerButton,
  MessageForm,
  MessageInput,
  MobileDetection,
  Modal,
  PacklinkLinkAccountButton,
  PacklinkShippingLabelButton,
  PayoutMethodFormFields,
  Photos,
  PromoCodeRedemptionForm,
  RecentlyViewedListings,
  ReferralSurveyEmbed,
  RefundRequestFormFields,
  RegionalListings,
  ReverbShippingLabelsValueProp,
  ReverbHeader,
  SearchHeader,
  SellCSPPreview,
  ShipOrderHeader,
  ShippingRatesEditor,
  ShopSettingsVatLayout,
  SimilarCSPsRow,
  SiteFooterContainer,
  SmartRecruiterJobs,
  SiteSearch,
  StarRating,
  StarRatingSelector,
  Subscriptions,
  TaxPolicyUS,
  UpdateOfferButton,
  WatchedListings,
  alt,
  buildReverbRouter,
  buildRootRoutes,
  DiscoveryRoutes,
} from '@reverbdotcom/discovery-ui';

import {
  TooltipPanel,
} from '@reverbdotcom/commons';

import trackPageView from './track_page_view';

window.Reverb = window.Reverb || {};
window.ReverbAppProviderV2 = AppProvider;
window.Reverb.AffirmBanner = AffirmBanner;
window.Reverb.AffirmCartOptionText = AffirmCartOptionText;
window.Reverb.AutoOfferModalButton = AutoOfferModalButton;
window.Reverb.BrowserInfoHiddenFields = BrowserInfoHiddenFields;
window.Reverb.BulkSaleModalButton = BulkSaleModalButton;

// bump components
window.Reverb.BumpDisplay = BumpDisplay;
window.Reverb.BumpBid = BumpBid;
window.Reverb.ListingRowBumpButton = ListingRowBumpButton;

window.Reverb.CategoryNestedNav = CategoryNestedNav;
window.Reverb.CombineAndSaveRow = CombineAndSaveRow;
window.Reverb.CreateOfferButton = CreateOfferButton;
window.Reverb.Spinner = Spinner;
window.Reverb.ListingSidebarCSP = ListingSidebarCSP;
window.Reverb.FeedbackContainer = FeedbackContainer;
window.Reverb.FreeShippingProgressBarContainer = FreeShippingProgressBarContainer;
window.Reverb.HomepageCuratedSetRow = HomepageCuratedSetRow;
window.Reverb.LightboxImage = LightboxImage;
window.Reverb.ListingRow = ListingRow;
window.Reverb.LocalePickerButton = LocalePickerButton;
window.Reverb.Modal = Modal;
window.Reverb.PacklinkLinkAccountButton = PacklinkLinkAccountButton;
window.Reverb.PacklinkShippingLabelButton = PacklinkShippingLabelButton;
window.Reverb.PayoutMethodFormFields = PayoutMethodFormFields;
window.Reverb.RecentlyViewedListings = RecentlyViewedListings;
window.Reverb.ReferralSurveyEmbed = ReferralSurveyEmbed;
window.Reverb.RegionalListings = RegionalListings;
window.Reverb.ReverbShippingLabelsValueProp = ReverbShippingLabelsValueProp;
window.Reverb.ShippingRatesEditor = ShippingRatesEditor;
window.Reverb.SimilarCSPsRow = SimilarCSPsRow;
window.Reverb.SearchBarV2 = SiteSearch;
window.Reverb.ReverbHeader = ReverbHeader;
window.Reverb.SearchHeader = SearchHeader;
window.Reverb.ShopSettingsVatLayout = ShopSettingsVatLayout;
window.Reverb.SiteFooter = SiteFooterContainer;
window.Reverb.AffirmEstimateCTA = AffirmEstimateCTA;
window.Reverb.SmartRecruiterJobs = SmartRecruiterJobs;
window.Reverb.StarRating = StarRating;
window.Reverb.StarRatingSelector = StarRatingSelector;
window.Reverb.Subscriptions = Subscriptions;
window.Reverb.TaxPolicyUS = TaxPolicyUS;
window.Reverb.UpdateOfferButton = UpdateOfferButton;
window.Reverb.WatchedListings = WatchedListings;
window.Reverb.SellCSPPreview = SellCSPPreview;
window.Reverb.AddressBook = AddressBook;
window.Reverb.CheckoutAddressBook = CheckoutAddressBook;
window.Reverb.EmailSignUp = EmailSignUpEmbed;
window.Reverb.EuOdrDetailsContainer = EuOdrDetailsContainer;
window.Reverb.EuOdrDetailsDashboardContainer = EuOdrDetailsDashboardContainer;
window.Reverb.GiftCardSendDatePicker = GiftCardSendDatePicker;
window.Reverb.ShipOrderHeader = ShipOrderHeader;
window.Reverb.Photos = Photos;
window.Reverb.ItemRelatedBuyingGuide = ItemRelatedBuyingGuide;
window.Reverb.RefundRequests = {
  FormFields: RefundRequestFormFields,
};
window.Reverb.CartItemActions = CartItemActions;
window.Reverb.Item2ShippingPrompt = Item2ShippingPrompt;

window.Reverb.CommonAlt = alt;
window.RREHelmet = Helmet;

window.Reverb.Routes = buildRootRoutes(DiscoveryRoutes); // exposed for server side rendering
setRoutes(window.Reverb.Routes);

window.Reverb.noRouterContext = true;
window.Reverb.Router = buildReverbRouter(DiscoveryRoutes, {
  onUpdate: () => {
    trackPageView(window.location);
    window.Reverb.noRouterContext = false;
  },
});

window.Reverb.MobileDetection = MobileDetection;

window.Reverb.Conversations = window.Reverb.Conversations || {};
window.Reverb.Conversations.BodyInput = MessageInput;
window.Reverb.Conversations.Form = MessageForm;
window.Reverb.PromoCodeRedemptionForm = PromoCodeRedemptionForm;
window.Reverb.TooltipPanel = TooltipPanel;



// WEBPACK FOOTER //
// ./javascripts/components/discovery.js